import { Violation } from 'src/types/ViewModel/Stowage/Violation/Violation';

export const createViolationChangeData = (violation: Violation): Partial<Violation> => {
    return {
        stowageRuleId: violation.stowageRuleId,
        type: violation.type,
        status: violation.status,
        statusChangedBy: violation.statusChangedBy,
        statusChangedUtc: violation.statusChangedUtc,
        description: violation.description,
        portCallGuid: violation.portCallGuid,
        berthCallGuid: violation.berthCallGuid,
        cargoOperationGuid: violation.cargoOperationGuid,
        cargoGuid: violation.cargoGuid,
        tankId: violation.tankId,
        adjacentTankId: violation.adjacentTankId,
    };
};
